import { render, staticRenderFns } from "./SupplementalCostCapture.vue?vue&type=template&id=55244375&scoped=true"
import script from "./SupplementalCostCapture.vue?vue&type=script&lang=js"
export * from "./SupplementalCostCapture.vue?vue&type=script&lang=js"
import "./SupplementalCostCapture.vue?vue&type=style&index=0&id=55244375&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55244375",
  null
  
)

export default component.exports